module.exports = __webpack_public_path__ + "img/set_1000.1dac22f1.png";